import { Button } from "@/components";
import { useDesignMaxTheme, useModal } from "@/packages";
import { useBookingRecoilValue, useNewNavigate } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { RoomsModal } from "../../../roomsModal";

export const OtherRoom = ({ room }: { room: RoomType }) => {
    const { onNavigate } = useNewNavigate();
    const { openModal, setModalContent, setIconName } = useModal();
    const { MEDIAS } = useDesignMaxTheme();
    const bookingURL = useBookingRecoilValue();

    const { imgList, room_idx, room_name, room_type, room_size, people } = { ...room };
    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    const { isMobile } = MEDIAS();
    return (
        <Flex w="100%" flexDir={isMobile ? "column" : "row"} gap={isMobile ? "8px" : "24px"}>
            <Box
                cursor="pointer"
                position="relative"
                flex={isMobile ? "none" : "1"}
                w={isMobile ? "100%" : "auto"}
                h={isMobile ? "212px" : "372px"}
                bg={imgList[0] ? `url(${imgList[0].img_URL})no-repeat center/cover` : "gray.100"}
                onClick={() => {
                    if (!isMobile) {
                        openModal();
                        setModalContent(<RoomsModal targetRoomIdx={room_idx} />);
                        setIconName("close");
                    }
                }}
            >
                <Center
                    position="absolute"
                    right="24px"
                    bottom="24px"
                    p="4px 8px"
                    borderRadius="17px"
                    bg="rgba(0,0,0,0.6)"
                    color="#fff"
                >
                    <Text fontSize="12px" className="material-icons-outlined">
                        image
                    </Text>
                    <Text {...FONT("pretendard", 12, 600, 1.4)}>{`+ ${imgList.length}`}</Text>
                </Center>
            </Box>
            <Flex w={isMobile ? "100%" : "372px"} flexDir="column" gap={isMobile ? "24px" : "84px"} p="8px 0">
                <Flex
                    flexDir="column"
                    gap={isMobile ? "8px" : "16px"}
                    sx={{
                        "& div > p:first-of-type": {
                            color: "#3b6c8d",
                        },
                    }}
                >
                    <Text color="#333" {...FONT("notoSerif", 24, 400, 1.4)}>
                        {room_name}
                    </Text>
                    <Box>
                        <Text>Room Type</Text>
                        <Text>{room_type}</Text>
                    </Box>
                    <Box>
                        <Text>Number of People</Text>
                        <Text>
                            기준 {people.min}인 ~ 최대 {people.max}인
                        </Text>
                    </Box>
                    <Box>
                        <Text>Room Size</Text>
                        <Text>{`${room_size}㎡`}</Text>
                    </Box>
                    {/* <Box>
                        <Text>Room Info</Text>
                        <Flex gap="24px">
                            <Text>Checkin 시간</Text>
                            <Text>CheckOut 시간</Text>
                        </Flex>
                    </Box> */}
                </Flex>
                <Flex
                    gap="16px"
                    sx={{
                        "& button": {
                            ...FONT("pretendard", 16, 500, 1.5),
                        },
                    }}
                >
                    <Button
                        w={isMobile ? "100% !important" : "128px !important"}
                        sizeType="mediumLarge"
                        roundType="none"
                        borderType="navy"
                        color="#3b6c8d"
                        onClick={() => onNavigate({ path: `/rooms/${room_idx}` })}
                    >
                        자세히보기
                    </Button>
                    <Button
                        w={isMobile ? "100% !important" : "128px !important"}
                        sizeType="mediumLarge"
                        roundType="none"
                        borderType="navy"
                        backgroundType="navy"
                        onClick={() => onLink(bookingURL)}
                    >
                        예약하기
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};
